import { Icon } from '@chakra-ui/react';

export default function StatusMissingLinkIcon({ onLabel, ...props }) {
  return (
    <Icon
      width='20px'
      height='20px'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M15.7878 17.0116C13.9779 17.0116 12.4805 15.5272 12.4805 13.7043C12.4805 11.8944 13.9779 10.397 15.7878 10.397C17.6042 10.397 19.0951 11.8879 19.0951 13.7043C19.0951 15.5142 17.5846 17.0116 15.7878 17.0116ZM15.7878 14.2642C16.0156 14.2642 16.1784 14.1079 16.1849 13.8866L16.237 12.0246C16.2435 11.7576 16.0612 11.5754 15.7878 11.5754C15.5143 11.5754 15.3385 11.7576 15.3451 12.0246L15.3971 13.8866C15.4036 14.1079 15.5599 14.2642 15.7878 14.2642ZM15.7878 15.8136C16.0938 15.8136 16.3346 15.5728 16.3411 15.2668C16.3411 14.9673 16.0938 14.7134 15.7878 14.7134C15.4883 14.7134 15.2409 14.9673 15.2409 15.2668C15.2409 15.5728 15.4883 15.8136 15.7878 15.8136Z'
        fill={onLabel ? 'white' : '#A82E2E'}
      />
      <path
        d='M10 16.9399C6.36719 16.9399 3.35938 13.9256 3.35938 10.2993C3.35938 6.6665 6.36068 3.65869 9.99349 3.65869C13.3789 3.65869 16.2305 6.28239 16.5951 9.58968C16.263 9.51807 15.7878 9.49202 15.4688 9.5376C15.0977 6.83577 12.7995 4.76546 9.99349 4.76546C6.92057 4.76546 4.47266 7.2264 4.47266 10.2993C4.47266 13.3722 6.92708 15.8332 10 15.8332C10.7031 15.8332 11.3802 15.6965 11.9922 15.4556C12.1484 15.7941 12.3438 16.1131 12.5911 16.3996C11.7904 16.7511 10.9115 16.9399 10 16.9399ZM6.58854 11.0024C6.33464 11.0024 6.13932 10.8071 6.13932 10.5467C6.13932 10.2928 6.33464 10.0975 6.58854 10.0975H9.54427V6.15869C9.54427 5.90478 9.73958 5.70947 9.99349 5.70947C10.2474 5.70947 10.4492 5.90478 10.4492 6.15869V10.5467C10.4492 10.8071 10.2474 11.0024 9.99349 11.0024H6.58854Z'
        fill={onLabel ? 'white' : '#2F63D9'}
      />
    </Icon>
  );
}
